export default __webpack_public_path__ + "static/media/7.eb8ae50b.png";